// Unlisted family records page — direct downloads for documents the family prints/signs.
// Not linked from any menu; reach it by adding /letter to the site address.
const CREAM = "#ecd9b8";
const TAN = "#a39478";

export default function FamilyLetter() {
  return (
    <div className="min-h-screen flex items-center justify-center p-6" style={{ background: "#12100c" }}>
      <div className="w-full max-w-sm rounded-2xl border p-6 text-center space-y-4"
        style={{ borderColor: "#3a352c", background: "rgba(255,255,255,0.02)" }}>
        <p className="text-[10px] font-mono tracking-widest uppercase" style={{ color: TAN }}>
          The Shepard Family — Records
        </p>
        <h1 className="text-xl font-semibold" style={{ color: CREAM }}>Response Letter</h1>
        <p className="text-xs leading-relaxed" style={{ color: TAN }}>
          One page. Notice and response to the initial assessment contact — sign and date by hand.
        </p>
        <a
          data-testid="letter-download-button"
          href="/story/private/shepard-family-response-letter.pdf"
          download="Shepard-Family-Response-Letter.pdf"
          className="block w-full rounded-full py-3 text-sm font-semibold transition-opacity hover:opacity-80"
          style={{ background: CREAM, color: "#12100c" }}
        >
          Download the letter (PDF)
        </a>
      </div>
    </div>
  );
}
